import * as types from './mutation-types'
import { API_STATES } from '@/helpers'

const mutations = {
  [types.GET_RESET_PASSWORD_VERIFICATION_BEGIN](state) {
    state.getResetPasswordVerificationState = API_STATES.REQUEST_PENDING
  },
  [types.GET_RESET_PASSWORD_VERIFICATION_SUCCESS](state) {
    state.getResetPasswordVerificationError = null
    state.getResetPasswordVerificationState = API_STATES.REQUEST_SUCCESS 
  },
  [types.GET_RESET_PASSWORD_VERIFICATION_ERROR](state, err) {
    state.getResetPasswordVerificationError = err
    state.uEmail=err.response.data.email
    state.uName=err.response.data.username
    state.getResetPasswordVerificationState = API_STATES.REQUEST_ERROR
  },

  [types.FORGOT_PASSWORD_VERIFICATION_BEGIN](state) {
    state.forgotPasswordVerificationState = API_STATES.REQUEST_PENDING
  },
  [types.FORGOT_PASSWORD_VERIFICATION_SUCCESS](state,message) {
    state.forgotPasswordVerificationError = null
    state.forgotPasswordVerificationState = API_STATES.REQUEST_SUCCESS 
    state.sendLinkMessage = message.message
  },
  [types.FORGOT_PASSWORD_VERIFICATION_ERROR](state, err) {
    state.forgotPasswordVerificationError = err
    state.forgotPasswordVerificationState = API_STATES.REQUEST_ERROR
  },

  [types.RESET_PASSWORD_VERIFICATION_BEGIN](state) {
    state.resetPasswordVerificationState = API_STATES.REQUEST_PENDING
  },
  [types.RESET_PASSWORD_VERIFICATION_SUCCESS](state,{ message, email }) {
    state.resetPasswordVerificationError = null
    state.resetPasswordVerificationState = API_STATES.REQUEST_SUCCESS 
    state.resetPasswordMessage = message
    state.userEmail = email
  },
  [types.RESET_PASSWORD_VERIFICATION_ERROR](state, err) {
    state.resetPasswordVerificationError = err
    state.resetPasswordVerificationState = API_STATES.REQUEST_ERROR
  }
}

export default mutations
